import api from '@/api/jobPosterAmbassador'

const state = {
}

const actions = {
  uploadJobPosterAmbassador (context, file) {
    return api.uploadJobPosterAmbassador(file)
  },
  getJobPosterAmbassadorList () {
    return api.getJobPosterAmbassadorList()
  },
  getJobPosterAmbassadorById (context, ambassadorId) {
    return api.getJobPosterAmbassadorById(ambassadorId)
  },
  addJobPosterAmbassador (context, ambassadorInfo) {
    return api.addJobPosterAmbassador(ambassadorInfo)
  },
  updateJobPosterAmbassador (context, ambassadorInfo) {
    return api.updateJobPosterAmbassador(ambassadorInfo)
  },
  checkAccountIsAmbassador (context, params) {
    return api.checkAccountIsAmbassador(params)
  },
  uploadAmbassadorJobPoster (context, posterInfo) {
    return api.uploadAmbassadorJobPoster(posterInfo)
  },
  deleteAmbassadorJobPoster (context, { companyId, ambassadorPosterId }) {
    return api.deleteAmbassadorJobPoster(companyId, ambassadorPosterId)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
